import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SelectModule } from '@rappi/ui/select';

import { ReportAutomationRoutingModule } from './report-automation-routing.module';
import { ReportAutomationComponent } from './report-automation/report-automation.component';
import { NewReportModalComponent } from './report-automation/components/new-report-modal/new-report-modal.component';
import { SearchSelectComponent } from './report-automation/components/search-select/search-select.component';
import { DatePickerFieldComponent } from './report-automation/components/date-picker-field/date-picker-field.component';

@NgModule({
  declarations: [
    ReportAutomationComponent,
    NewReportModalComponent,
    SearchSelectComponent,
    DatePickerFieldComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    SelectModule,
    ReportAutomationRoutingModule
  ]
})
export class ReportAutomationModule {}
